'use client';

import { useAuth, useClerk } from '@clerk/nextjs';
import { AUTH_ROUTES } from '@lib/constants/apis';
import { clearGreetingShownFlag } from '@lib/everything-bar/chat/hooks/use-first-login-chat';
import { clearPortalLoginSessionKeys } from '@lib/observability/lifecycle/constants';
import { useQueryClient } from '@lib/query/client';
import { clearSubmissionTokenCookie } from '@lib/submissions/utils/submission-token-cookie';

type SignOutOptions = {
  redirectUrl?: string;
};

export function useSignOut() {
  const { signOut } = useClerk();
  const { userId } = useAuth();
  const queryClient = useQueryClient();

  return (options?: SignOutOptions | (() => void)) => {
    const userIdToClear = userId ?? undefined;
    queryClient.clear();
    clearSubmissionTokenCookie();
    clearGreetingShownFlag();
    if (typeof options === 'function') {
      return signOut(() => {
        clearPortalLoginSessionKeys(userIdToClear);
        options();
      });
    }
    const signOutPromise = signOut({
      redirectUrl: options?.redirectUrl ?? AUTH_ROUTES.LOGIN,
    });
    void Promise.resolve(signOutPromise).finally(() => {
      clearPortalLoginSessionKeys(userIdToClear);
    });
    return signOutPromise;
  };
}
